var _style, _g, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _defs, _defs2, _polygon7, _polygon8, _polygon9, _path, _rect, _polygon10, _g2, _path2, _g3, _defs3, _path3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvothermMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st3{fill:#808080;}\n\t.st4{fill:#C9C9C9;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{opacity:0.75;fill:#FFFFFF;}\n\t.st7{clip-path:url(#SVGID_4_);fill:#4C4C4C;}\n\t.st8{clip-path:url(#SVGID_4_);fill:#808080;}\n\t.st9{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n\t.st10{fill:#0AAEFF;}\n\t.st11{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#4C4C4C;stroke-width:2;stroke-miterlimit:10;}\n\t.st13{fill:#4C4C4C;}\n\t.st14{display:none;fill:#C9C9C9;stroke:#808080;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st15{clip-path:url(#SVGID_6_);fill:#4C4C4C;}\n\t.st16{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 250,
    cy: 250,
    r: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "421,106.2 218.8,52 85,129.4 70.9,184.2 70.9,372.7 82.7,375.2 82.7,392.6 284.9,446.8 421.1,368.2  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "273.2,238.4 273.2,426.9 70.9,372.7 70.9,184.2  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "287.2,183.6 421,106.2 218.8,52 85,129.4  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "284.9,446.8 284.9,420.1 273.2,426.9 70.9,372.7 82.7,385.5 82.7,392.6  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "85,129.4 287.2,183.6 273.2,238.4 70.9,184.2  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "82.7,385.5 284.9,440.2 284.9,420.1 273.2,426.9 70.9,372.7  "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M106.1,172.5l-5.1,19.8l172.2,46.1l12.7-49.8l-142.2-38.1C127.2,146.1,110.3,156,106.1,172.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M97.6,213.3v114.5c0,14.4,9.7,27,23.6,30.7l100.8,27c12.1,3.2,24-5.9,24-18.4v-114L97.6,213.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "87.6,358 203.8,290.9 203.8,222.2 87.6,199.3  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "203.8,290.9 264.2,307.1 264.2,404.6 87.6,358  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "203.8,290.9 264.2,307.1 266,236.5 203.8,222.2  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M236,377.4l-100.8-27c-13.9-3.7-23.6-16.3-23.6-30.7V217.1l-14-3.8v114.5c0,14.4,9.7,27,23.6,30.7l100.8,27 c8.2,2.2,16.2-1.3,20.6-7.6C240.5,378.2,238.2,378,236,377.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 202.6,
    className: "st8",
    width: 181.9,
    height: 190.9
  }))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "173,172.2 163.6,209 215.2,222.9 224.6,186.1  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 284.9,
    y1: 420.1,
    x2: 284.9,
    y2: 231.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "421,153 273.2,238.4 70.9,184.2  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M74.1,302.3c0,5.7,3.6,11,8.1,12c4.5,1,8.1-2.9,8.1-8.5v-25.2c0-5.7-3.6-11.1-8.1-12.1 c-4.5-1-8.1,2.9-8.1,8.5V302.3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.6,306c-0.3,0-0.7,0-1.1-0.1c-3.7-0.8-6.7-5.4-6.7-10.2c0-2.8,1-5.1,2.8-6.3c0.6-0.4,2.5-1.5,4.4-2.5 c1.9-1.1,3.9-2.2,4.7-2.7c0.7-0.5,1.5-0.7,2.4-0.7c0.3,0,0.7,0,1.1,0.1c3.7,0.8,6.7,5.4,6.7,10.2c0,2.8-1.1,5.2-2.9,6.3 c-0.6,0.4-2.5,1.4-4.3,2.5c-1.9,1.1-3.9,2.2-4.7,2.7C75.2,305.8,74.5,306,73.6,306L73.6,306z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M80.1,284.5c0.3,0,0.6,0,0.9,0.1c3.2,0.7,5.9,4.9,5.9,9.2c0,2.5-0.9,4.5-2.4,5.5c-0.6,0.4-2.4,1.4-4.3,2.4 c-2,1.1-3.9,2.2-4.7,2.7c-0.6,0.3-1.2,0.5-1.8,0.5c-0.3,0-0.6,0-0.9-0.1c-3.2-0.7-5.9-4.9-5.9-9.2c0-2.5,0.9-4.5,2.3-5.5 c0.5-0.4,2.5-1.5,4.3-2.5c2-1.1,3.9-2.2,4.7-2.7C78.8,284.7,79.4,284.5,80.1,284.5 M80.1,282.5c-1.1,0-2.1,0.3-2.9,0.9 c-1.5,1-7.8,4.4-9.1,5.2c-2,1.3-3.2,3.9-3.2,7.1c0,5.3,3.4,10.3,7.5,11.2c0.4,0.1,0.9,0.1,1.3,0.1c1,0,2-0.3,2.9-0.8 c1.6-1,7.8-4.4,9-5.2c2-1.3,3.3-3.9,3.3-7.2c0-5.3-3.4-10.3-7.5-11.2C80.9,282.6,80.5,282.5,80.1,282.5L80.1,282.5z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9572 -0.2893 0.2893 0.9572 -82.9349 33.6463)",
    className: "st14",
    cx: 72.3,
    cy: 297.4,
    rx: 7.3,
    ry: 9.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M79.8,299.1c0-5.3-3.4-10.3-7.5-11.2c-1.2-0.3-2.3-0.2-3.2,0.2c-1.1,0.4-5.1,2.8-6,3.4 c-1.8,1.3-3,3.8-3,6.9v62.7c0,3.3,2.2,6.2,5.5,7.1l6.3,1.7c1.7,0.5,4-0.6,5-1.3c1.8-1.2,3-2.9,3-5.5V299.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M75.1,301.8c0-5.3-3.4-10.3-7.5-11.2s-7.5,2.6-7.5,7.9v62.7c0,3.3,2.2,6.2,5.5,7.1l6.1,1.6 c1.8,0.5,3.5-0.9,3.5-2.7V301.8z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "H2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -1350.5,
    y1: 165,
    x2: 694.2,
    y2: 712.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -678.8,
    y1: -117.9,
    x2: 1365.9,
    y2: 430
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -406.1,
    y1: 491.9,
    x2: 1511.4,
    y2: -615.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 263.1,
    y1: -365.3,
    x2: 263.1,
    y2: 1278.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -734.7,
    y1: 953.8,
    x2: 1182.8,
    y2: -153.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -755.7,
    y1: 801.2,
    x2: 1161.7,
    y2: -305.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -993.3,
    y1: 7,
    x2: 1051.4,
    y2: 554.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -993.1,
    y1: 22.6,
    x2: 1051.6,
    y2: 570.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -1082.2,
    y1: 11.1,
    x2: 962.5,
    y2: 559
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 356,
    y1: -395.8,
    x2: 356,
    y2: 1248.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 135.9,
    y1: -328.5,
    x2: 135.9,
    y2: 1315.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 228.9,
    y1: -415.9,
    x2: 228.9,
    y2: 1228.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -1091.7,
    y1: -2,
    x2: 953,
    y2: 545.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -787.4,
    y1: -72.4,
    x2: 1257.4,
    y2: 475.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -791.8,
    y1: -77,
    x2: 1252.9,
    y2: 470.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -763.6,
    y1: 843.1,
    x2: 1153.9,
    y2: -264
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: -899.7,
    y1: -24.4,
    x2: 1145,
    y2: 523.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvothermMini);
export default __webpack_public_path__ + "static/media/ConvothermMini.2b9f8b19f84c69e59ae3fac3b545a361.svg";
export { ForwardRef as ReactComponent };